<template>
  <div class="sales-report__wrapper">

    <div class="css-grid sales-report__header sales-report__header--transactions">
      <div class="sales-report__header-name">{{ decode(entityData.name) || title || '(Unmatched)' }}</div>
      <div class="sales-report__header-transactions" title="Download transactions for this data" v-on:click="downloadTransactions">
          <span class="sales-report__header-transactions-icon glyphicon glyphicon-circle-arrow-down" aria-hidden="true"></span>
          Transactions
      </div>
    </div>

    <div class="css-grid sales-report__body">
      <div class="css-grid sales-report__sidebar">
        <div class="css-grid sales-report-sidebar__category">
          <div class="sales-report-sidebar__category-box">
            <div class="sales-report-sidebar__category-title">UNITS</div>
          </div>
          <div class="sales-report-sidebar__category-box">
            <div class="sales-report-sidebar__category-subtitle">Active</div>
            <div class="sales-report-sidebar__category-number">{{ this.currency(totals.units) }}</div>
          </div>
          <div class="sales-report-sidebar__category-box">
            <div class="sales-report-sidebar__category-subtitle">Runrate</div>
            <div class="sales-report-sidebar__category-number">{{ this.currency(totals.est_units) }}</div>
          </div>
          <div class="sales-report-sidebar__category-box" data-toggle="tooltip" :title="'Runrate vs. Prior '+this.currency(totals.yoy_units)">
            <div class="sales-report-sidebar__category-number sales-report-sidebar__category-number--only" v-bind:class="[ getChangePercent(totals.est_units, totals.yoy_units) >= 0 ? 'sales-report-sidebar__category-number--positive' : 'sales-report-sidebar__category-number--negative']">
              {{ getChangePercent(totals.est_units, totals.yoy_units) }}%
            </div>
          </div>
        </div>

        <div class="css-grid sales-report-sidebar__category">
          <div class="sales-report-sidebar__category-box">
            <div class="sales-report-sidebar__category-title">SALES</div>
          </div>
          <div class="sales-report-sidebar__category-box">
            <div class="sales-report-sidebar__category-subtitle">Active</div>
            <div class="sales-report-sidebar__category-number">${{ this.currency(totals.sales) }}</div>
          </div>
          <div class="sales-report-sidebar__category-box">
            <div class="sales-report-sidebar__category-subtitle">Runrate</div>
            <div class="sales-report-sidebar__category-number">${{ this.currency(totals.est_sales) }}</div>
          </div>
          <div class="sales-report-sidebar__category-box" data-toggle="tooltip" :title="'Runrate vs. Prior $'+this.currency(totals.yoy_sales)">
            <div class="sales-report-sidebar__category-number sales-report-sidebar__category-number--only" v-bind:class="[ getChangePercent(totals.est_sales, totals.yoy_sales) >= 0 ? 'sales-report-sidebar__category-number--positive' : 'sales-report-sidebar__category-number--negative']">
              {{ getChangePercent(totals.est_sales, totals.yoy_sales) }}%
            </div>
          </div>
        </div>

        <div class="css-grid sales-report-sidebar__category">
          <div class="sales-report-sidebar__category-box">
            <div class="sales-report-sidebar__category-title">ASP</div>
          </div>
          <div class="sales-report-sidebar__category-box">
            <div class="sales-report-sidebar__category-subtitle">Active</div>
            <div class="sales-report-sidebar__category-number">${{ this.currency(divide(totals.sales, totals.units)) }}</div>
          </div>
          <div class="sales-report-sidebar__category-box">
            <div class="sales-report-sidebar__category-subtitle">Prior</div>
            <div class="sales-report-sidebar__category-number">${{ this.currency(divide(totals.yoy_sales, totals.yoy_units)) }}</div>
          </div>
          <div class="sales-report-sidebar__category-box">
            <div class="sales-report-sidebar__category-number sales-report-sidebar__category-number--only" v-bind:class="[ getChangePercent(divide(totals.sales, totals.units), divide(totals.yoy_sales, totals.yoy_units)) >= 0 ? 'sales-report-sidebar__category-number--positive' : 'sales-report-sidebar__category-number--negative']">
              {{ getChangePercent(divide(totals.sales, totals.units), divide(totals.yoy_sales, totals.yoy_units)) }}%
            </div>
          </div>
        </div>

        <div class="css-grid sales-report-sidebar__category">
          <div class="sales-report-sidebar__category-box">
            <div class="sales-report-sidebar__category-title">MONTHLY</div>
          </div>
          <div class="sales-report-sidebar__category-box">
            <div class="sales-report-sidebar__category-subtitle">AVG Units</div>
            <div class="sales-report-sidebar__category-number">{{ this.currency(totals.avg_units) }}</div>
          </div>
          <div class="sales-report-sidebar__category-box">
            <div class="sales-report-sidebar__category-subtitle">AVG Sales</div>
            <div class="sales-report-sidebar__category-number">${{ this.currency(totals.avg_sales) }}</div>
          </div>
          <div class="sales-report-sidebar__category-box">
            <div class="sales-report-sidebar__category-subtitle">AVG ASP</div>
            <div class="sales-report-sidebar__category-number">${{ this.currency(totals.avg_asp) }}</div>
          </div>
        </div>

        <div class="css-grid sales-report-sidebar__category sales-report-sidebar__category--fuel-time">
          <div class="sales-report-sidebar__category-box">
            <div class="sales-report-sidebar__category-title sales-report-sidebar__category-title--fuel-time">FUEL TIME</div>
          </div>
          <div class="sales-report-sidebar__category-box">
            <div class="sales-report-sidebar__category-number">{{ this.currency(totals.fuel_minutes / 60) }} hours</div>
          </div>
        </div>
      </div>


      <div class="sales-report__main">
        <!--
        <div class="sales-report__tab-group">
          <span class="sales-report__tab tab" v-on:click="currentTab = 'MixSales'" v-bind:class="[{ active: currentTab === 'MixSales' }]">Sales Mix</span>
          <span class="sales-report__tab tab" v-on:click="currentTab = 'TrendSales'" v-bind:class="[{ active: currentTab === 'TrendSales' }]">Sales Trend</span>
          <span class="sales-report__tab tab" v-on:click="currentTab = 'TrendUnits'" v-bind:class="[{ active: currentTab === 'TrendUnits' }]">Units Trend</span>
          <span class="sales-report__tab tab" v-on:click="currentTab = 'TrendVendors'" v-bind:class="[{ active: currentTab === 'trend-vendors' }]">Vendors Trend</span>
          <span class="sales-report__tab tab" v-on:click="currentTab = 'TopProducts'" v-bind:class="[{ active: currentTab === 'top-products' }]">Top Products</span>
        </div>
        -->
        <div class="sales-report__tab-body" v-bind:class="[{ 'sales-report__tab-body--empty': currentTab === '' }]">
          <MixSales v-show="currentTab == 'MixSales'" :entity-data="entityData" :filters="localFilterString"></MixSales>
          <TrendSales v-show="currentTab == 'TrendSales'" :show-trend="showTrend" :formatted-data="formattedSalesData"></TrendSales>
          <TrendUnits v-if="currentTab == 'TrendUnits'" :show-trend="showTrend" :formatted-data="formattedUnitsData"></TrendUnits>
          <TrendVendors v-if="currentTab == 'TrendVendors'" :show-trend="showTrend" :formatted-data="formattedVendorsData"></TrendVendors>
          <TopProducts v-if="currentTab == 'TopProducts'" :show-trend="showTrend" :formatted-data="formattedProductData"></TopProducts>
        </div>
      </div>
    </div>

    <div class="css-grid sales-report__footer">
      <SalesDetails :months="trendData" :show="displayDetails"></SalesDetails>
      <div class="sales-report__footer--more">
        <div class="sales-report__footer-expandable" v-on:click="toggleDetails" v-show="showTrend">{{ displayDetails ? '- Hide sales details' : '+ Show sales details' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import qs from 'qs';
  import axios from 'axios';
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import TrendSales from './ReportBoxTrendSales.vue';
  import TrendUnits from './ReportBoxTrendUnits.vue';
  import MixSales from './ReportBoxMixSales.vue';
  import TrendVendors from './ReportBoxTrendVendors.vue';
  import TopProducts from './ReportBoxTopProducts.vue';
  import SalesDetails from './ReportBoxDetails.vue';
  import DataMethods from '../../utils/DataMethods.js';

  export default {
    name: 'ReportTotals',
    components: {
      TrendSales,
      TrendUnits,
      MixSales,
      TrendVendors,
      TopProducts,
      SalesDetails,
    },
    props: {
      title: '',
      entityData: {},
      activeFilters: {},
    },
    mixins: [DataMethods],
    data() {
      return {
        currentTab: '',
        displayDetails: false,
        showTrend: false,
        trendData: [],
        vendorTrendData: [],
        productData: [],
      };
    },
    computed: {
      ...mapGetters('purchaseActivityFlash', [
        'apiFilters',
        'cancelToken',
        'contents',
        'filters',
      ]),
      totals() {
        return this.entityData.totals;
      },
      localFilters() {
        return {
          ...this.apiFilters,
          filters: {
            ...this.apiFilters.filters,
            ...this.activeFilters,
          },
        };
      },
      localFilterString() {
        return qs.stringify(this.localFilters, { arrayFormat: 'brackets' });
      },
      formattedSalesData() {
        return {
          'months': lodash.map(this.trendData, 'month'),
          'Sales': lodash.map(this.trendData, 'sales'),
          'Prior': lodash.map(this.trendData, 'yoy_sales'),
        };
      },
      formattedUnitsData() {
        return {
          'months': lodash.map(this.trendData, 'month'),
          'Units': lodash.map(this.trendData, 'units'),
          'Prior': lodash.map(this.trendData, 'yoy_units'),
        };
      },
      formattedVendorsData() {
        return {
          'months': lodash.map(this.vendorTrendData, 'month'),
          'Oticon': lodash.map(this.vendorTrendData, 'oticon_units'),
          'Phonak': lodash.map(this.vendorTrendData, 'phonak_units'),
          'ReSound': lodash.map(this.vendorTrendData, 'resound_units'),
          'Signia': lodash.map(this.vendorTrendData, 'signia_units'),
          'Starkey': lodash.map(this.vendorTrendData, 'starkey_units'),
          'Sonic': lodash.map(this.vendorTrendData, 'sonic_units'),
          'Unitron': lodash.map(this.vendorTrendData, 'unitron_units'),
          'Widex': lodash.map(this.vendorTrendData, 'widex_units'),
        };
      },
      formattedProductData() {
        return this.productData;
      },
    },
    mounted() {
      // this.currentTab = (Math.abs(this.filterMonths) > 3 ? 'TrendSales' : 'MixSales'),
      // this.showTrend = (this.filterMonths > 1);
      this.currentTab = 'MixSales';
      this.showTrend = false;
      // this.getTotalsByMonth();
      // this.getTotalsByMonth();
      // this.getTopProducts();
      // this.getTotalsByVendorByMonthOneRow();
    },
    methods: {
      async toggleDetails () {
        this.displayDetails = !this.displayDetails;
      },

      downloadTransactions () {
        this.$store.dispatch('purchaseActivityFlash/downloadTransactions', this.localFilters);
      },

      decode (html) {
        const decoder = document.createElement('div');
        decoder.innerHTML = html;
        return decoder.textContent;
      },

      getTopProducts() {
        if (lodash.isEmpty(this.productData)) {
          this.loading = true;
          return axios.get(`/api/sales/hearing-aids/flash/member/topProducts/?${this.localFilterString}`, { cancelToken: this.cancelToken.token })
            .then((response) => {
              this.productData = response.data;
              this.loading = false;
            }).catch((thrown) => {});
        }
      },
    },
  };
</script>
